import { FC } from 'react';
import { useQuery } from 'react-query';
import MainLayout from 'components/main-layout/MainLayout';
import API from 'core/Api';
import IResponseData from 'types/api';
import { useParams } from 'react-router';
import EditForm from './components/EditForm';
import { IUser } from '../types';
import { IDropdowns } from '../components/types';

const Screen: FC = () => {
  const { id } = useParams<{ id: string | undefined }>();

  const { isLoading, error, data } = useQuery<IUser, Error>(
    ['user', { id }],
    (): Promise<IUser> => API.get<IResponseData<IUser>>(`users?id=${id}`).then(res => res.data?.items[0])
  );

  const {
    isLoading: isLoadingUserDropdowns,
    error: errorUserDropdowns,
    data: dropdowns,
  } = useQuery<IDropdowns, Error>(['user-dropdowns'], (): Promise<IDropdowns> => {
    return API.get('users/dropdown-options').then(res => res.data && res.data.bg);
  });

  return (
    <MainLayout
      title="Редактиране на оператор"
      isLoading={isLoading && isLoadingUserDropdowns}
      error={error || errorUserDropdowns}
    >
      {dropdowns && data && (
        <EditForm
          user={data}
          userDataOptions={dropdowns}
        />
      )}
    </MainLayout>
  );
};

export default Screen;
